import axios from "axios";
import Vue from "vue";

export function dingTalkLogin (parameter) {
  return axios({
    url:  `${Vue.prototype.vueAppUrl}/dingtalk/login`,
    method: 'POST',
    params: parameter
  })
}

export function dingTalkLoginAI (parameter) {
  return axios({
    url:  `${Vue.prototype.putureServerUrl}/puture-ai/auth/login`,
    method: 'POST',
    params: parameter
  })
}
